$(document).ready(function() {
      $(document).trigger('refresh_autonumeric');
});
